import React from 'react';
import Inmails from './inmails';

export default Inmails;
